import React, { useContext, useEffect } from "react";
import { Link, Route, Switch, useLocation, useParams } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/outline";
import { useSelector } from "react-redux";
import CollectionContentList from "../collections/ContentList";
import { CollectionContext } from "../../general/currentCollectionContext";
import { useIsLeftNavbarVisible } from "../../general/hooks/useIsLeftNavbarVisible";

const LeftNavbarWithRouter = () => {
  const location = useLocation();

  return (
    <Switch location={location}>
      <Route exact path="/" children={<LeftNavbar />} />
      <Route exact path="/dashboard" children={null} />
      <Route exact path="/dashboard/:page" children={null} />
      <Route exact path="/embed/:page" children={null} />
      <Route exact path="/reset-password" component={null} />
      <Route path="/creators" children={<LeftNavbar />} />
      <Route exact path="/profile/:userId" component={LeftNavbar} />
      <Route path="/search" children={<LeftNavbar />} />
      <Route path="/tags/:tag" children={<LeftNavbar />} />
      <Route exact path="/topic/:topic_slug" children={<LeftNavbar />} />
      <Route exact path="/viewcontent/:content_id" component={LeftNavbar} />
      <Route exact path="/:collection_slug" children={<LeftNavbar />} />
      <Route exact path="/:collection_slug/:content_id" component={LeftNavbar} />
    </Switch>
  );
};

const LeftNavbar = () => {
  const { collection } = useContext(CollectionContext);
  const { collection_slug } = useParams();
  const { currentUser } = useSelector(state => state.auth);
  const { platformData } = useSelector(state => state.frontend);
  const { isLeftNavbarVisible, setIsLeftNavbarVisible } = useIsLeftNavbarVisible();

  const isUserLoggedIn = currentUser?.id;

  useEffect(() => {
    setIsLeftNavbarVisible(isUserLoggedIn || collection_slug);
  }, [collection_slug, isUserLoggedIn, setIsLeftNavbarVisible]);

  if (!isLeftNavbarVisible) return null;
  return (
    <div className="w-80 hidden lg:flex lg:flex-shrink-0 fixed inset-0 shadow-xl overflow-y-scroll platform-dark-color bg-platform-light-color">
      <nav className="bg-gray-900 bg-opacity-5 p-3 pt-16 h-full w-full">
        {isUserLoggedIn && (
          <div className="text-lg mt-4 mb-2">
            <i>Welcome back,</i> <b className="block">{currentUser.name}</b>
          </div>
        )}

        {isUserLoggedIn && (
          <Link
            to="/"
            className="group flex items-center px-2 py-2 text-base font-medium rounded-md hover:opacity-100 opacity-80"
          >
            <HomeIcon className="h-6 w-6 mr-2" />
            Home
          </Link>
        )}
        {collection && collection_slug && (
          <>
            <Link
              to={`/${collection.slug}`}
              className="font-bold text-xl block mt-10 leading-none"
              style={{
                color: `${platformData.primaryColor}`
              }}
            >
              {collection.name}
            </Link>
            <CollectionContentList collection={collection} />
          </>
        )}
      </nav>
    </div>
  );
};

export default LeftNavbarWithRouter;
